/* eslint-disable */
import React, { Component, Fragment, useEffect, useState } from 'react';
import { Container, Card, CardBody, CardFooter, Row, Col, Button, Label, UncontrolledTooltip } from 'reactstrap';
import Tooltip from '@material-ui/core/Tooltip';
import DonutWidget from './DonutWidget';
import BatteryWidget from './BatteryWidget';
import AttribureIcon from './AttributeIcon';
import { MessageOutlineIcon, Battery70Icon } from 'mdi-react';
import {
    ATTRIBUTE_TYPE,
    ATTRIBUTE_NAME,
    TIME_ZONE,
    WHITE_COLOR,
    GREEN_COLOR,
    RED_COLOR,
    ORENGE_COLOR,
    YELLOW_COLOR,
    GREY_COLOR,
    LIGHT_GREY_COLOR,
    ATTRIBUTE_ORDER,
    ATTRIBUTE_WIND_ORDER,
    ALARM_META_ATTRI_OBJ,
    LEGEND_LIST,
    xxSmallTextStyle,
    xSmallTextStyle,
    smallTextStyle,
    normalTextStyle,
} from '../../../constants/dataConstants';
import moment from 'moment';
import { lightningColorMaper } from '../../../factories/weather';
import styled, { keyframes, css } from "styled-components";
import './blinking.scss';
import { ConsoleIcon, RelativeScaleIcon } from 'mdi-react';

const valueRowStyle = {
    margin: '-8px 18px',
    padding: '5px',
    justifyContent: 'space-between',
    // lineHeight: '30px',
    // minHeight: '30px'
}

const stationRowStyle = {
    // margin: '5px 10px',
    // padding: '5px',
    justifyContent: 'center'
}

const rowClass = {
    // color: 'black', 
    // fontWeight: 'normal',
    margin: '5px 10px',
    fontSize:'15px',
    padding: '5px 30px',
    justifyContent: 'space-evenly', //'center'
    alignContent: 'center',
    lineHeight: '30px',
    height: '30px',
    // backgroundColor: GREEN_COLOR, //hasrule ? GREEN_COLOR : GREY_COLOR,
    color: 'white',
    position: 'relative',
    // animation: 'alertBlink 1s infinite',
}
const backClass = {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    backgroundColor: GREEN_COLOR, //hasrule ? GREEN_COLOR : GREY_COLOR,
    animation: 'alertBlink 1s infinite',
}
const testClass = {
    color: 'black',
    position: 'absolute',
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    fontSize: '2.5vh',
    lineHeight: '2.5vh'
}

// const smallTextStyle = {
//     fontSize: '1.5vh',
//     lineHeight: '1.5vh',
// }

// const normalTextStyle = {
//     fontSize: '2vh',
//     lineHeight: '2vh',
// }


const AttributeListWidget = ({ alarmSet, asset, isSmall, toggle, activeTab }) => {
    let alarmObj = alarmSet ? alarmSet[asset.assetname] : null;
    let donutData = setDonut(alarmObj, asset.attributes);
    // return <div style={{ minWidth: '195px', maxWidth: '400px' }}>
    // if(ATTRIBUTE_WIND_ORDER) {
    //         console.log("===", ATTRIBUTE_WIND_ORDER)
    // };
    
    return <Col style={{ minWidth: '400px', maxWidth: '400px' }}>
        {/* <Row style={{ padding: '5px', justifyContent: 'center' }}>
            <DonutWidget status={donutData.status} color={donutData.color} />
        </Row> */}
        <Row style={stationRowStyle}>
            {/* <span style={normalTextStyle}>{assetnameFormat(asset, toggle)}</span> */}
            {/* <span style={{fontSize: '1rem', lineHeight: '1rem', whiteSpace: 'nowrap', overflow: 'hidden'}}>{assetnameFormat(asset, toggle)}</span> */}
            <span style={{fontSize: '1rem', lineHeight: '1rem', whiteSpace: 'nowrap'}}>{assetnameFormat(asset, toggle)}</span>
        </Row>
        <Row style={valueRowStyle}>
            {/* <span style={smallTextStyle}>{timestampFormat(asset.timestamp)}</span> */}
            <span style={{fontSize: '15px'}}><MessageOutlineIcon />Last Message</span>
            {/* <span style={{fontSize: '1rem', lineHeight: '1rem'}}>{timestampFormat(asset.timestamp)}</span> */}
            <span style={{fontSize: '15px'}}>{timestampFormat(asset.timestamp)}</span>
        </Row>
        {(activeTab == 1) ?
            ATTRIBUTE_ORDER && ATTRIBUTE_ORDER.filter(item => item.display).map(attr => (
                <AttributeDisplayElement
                    alarmObj={alarmObj}
                    attr={attr}
                    asset={asset}
                    isSmall={isSmall}
                />
            ))
            :
            ATTRIBUTE_WIND_ORDER && ATTRIBUTE_WIND_ORDER.filter(item => item.display).map(attr => (
                <AttributeDisplayElement
                    alarmObj={alarmObj}
                    attr={attr}
                    asset={asset}
                    isSmall={isSmall}
                />
            ))
    }

    </Col>
}

const AlarmDisplayElement = ({ attr, val, isSmall }) => {
    const key = attr.attributename;
    const displayName = attr.displayname;
    // const val = key === 'hexAlarm' ? asset[key] : null ;
    const colorVal = lightningColorMaper(val ? val.value : null);
    const status = val ? val.status : false;
    const displayObj = LEGEND_LIST.find(item => (item.color === colorVal));
  
    // return <Row style={rowClass}>
    //     {/* <Col md={12} > */}
    //     <div style={backClass}></div>
    //     <div style={testClass}>
    //         {isSmall && 
    //             <span style={{alignSelf: 'flex-start'}}>
    //                 <AttribureIcon attributeName={key}/>
    //             </span>
    //         }
    //         <span>{displayObj.label}{' '}{attr.units}</span>
    //     </div>
    //     {/* </Col> */}
    // </Row>
    return <Row style={rowClassGnerator(status, null, key, colorVal, true, isSmall)}>
        {isSmall &&
            <span style={{ fontSize:'15px', display: 'flex' }}>
                <AttribureIcon attributeName={key} />
                {displayName}
            </span>
       } 
        {/* <span style={{ ...(displayObj && displayObj.label && displayObj.label.length < 15 ? smallTextStyle : xSmallTextStyle), width: isSmall ? '80%' : '100%', textAlign: isSmall ? 'right' : 'center' }}> */}
        {/* <span style={{ ...(displayObj && displayObj.label && displayObj.label.length < 15 ? smallTextStyle : xSmallTextStyle), width: isSmall ? '80%' : '100%', textAlign: isSmall ? 'right' : 'center', fontSize: '1rem', lineHeight: '1rem' }}> */}
        <span style={{ ...(displayObj && displayObj.label && displayObj.label.length < 15 ? smallTextStyle : xSmallTextStyle), /* width: isSmall ? '80%' : '100%', */ textAlign: isSmall ? 'right' : 'center', fontSize: '15px', lineHeight: '1.5rem' }}>
            {displayObj ? displayObj.label : ''}
            {/* {' '}{attr.units} */}
        </span>
    </Row>
}

const BatteryDisplayElement = ({ alarmObj, attributeName, valArray, isSmall, displayName, newValArray }) => {
    // Declare deviceType here in order to get the battery index; Tempera
    const hcTechLightning = "6202b891a4da5eb7edfa0852"; // New Lightnning device type
    const meteoHelixPro = "5ea1941d0499f5146d8d5957"; // Weather device for Weather Station
    const meteoWindIotProWeather = "5ec5367ae833d907a4b11115"; // Wind device for Weather Station
    const meteoWindIotProFonturUltraContract = "612293a20499f50cdb3d8aec"; // Wind device for Wind station
    const meteoWindIotProWind= "60591125c563d60f5a1169b3";

    for(let i = 0; i < newValArray.length; i++) {
        newValArray[i].devicename = newValArray[i].devicetypename;
    };
    
    // Remove unnecessary attributes
    newValArray.forEach(object => {
        delete object['deviceNameAlias'];
        delete object['creationtime'];
        delete object['lastseqnumber'];
        delete object['trackable'];
        delete object['activable'];
        delete object['devicetypename'];
    });

    
    return (       
        <Row style={rowClassGnerator(false, null, attributeName, 'red', true, false)}>
            {newValArray && newValArray.map((val, index) => {
                let displayIndex = 0;
                if(displayName == 'Weather') {
                    displayIndex = newValArray.findIndex(x => x.devicetype === meteoHelixPro);
                } else if(displayName == 'Wind' || displayName == 'Battery') {
                    displayIndex = newValArray.findIndex(x => x.devicetype === meteoWindIotProWeather || x.devicetype === meteoWindIotProFonturUltraContract || x.devicetype === meteoWindIotProWind);
                }
                //  else if (displayName == 'Wind') {
                //     displayIndex = newValArray.findIndex(x => x.devicetype === meteoWindIotProFonturUltraContract)
                // } 

                var deviceIdRegNero = new RegExp("1B30D[a-zA-Z0-9]{2}|NS[0-9]{8}");
                if (!deviceIdRegNero.test(val.deviceid + val.devicename) && displayIndex == index) {
                    let value = parseFloat(val.value);
                    const id = `battery_${index}`;
                    if (alarmObj && alarmObj[val.deviceid] && alarmObj[val.deviceid][attributeName]) {
                        value = alarmObj[val.deviceid][attributeName].value;
                    }
                    let level = 0
                    let percentage = "0%";
                    if (Number.isNaN(value)) {
                        level = -1;
                        percentage = "No Battery Detected";
                    }
                    if (!Number.isNaN(value) && value > 3.6 && value < 4.3) {
                        //full battery: 4.3 | Empty battery 3.6
                        level = Math.round((((value - 3.6) / .7) * 5) - .5);
                        percentage = Math.round(((value - 3.6) / .7) * 100) + "%"
                    }
                    if (value >= 4.3) {
                        level = 4;
                        percentage = "100%" 
                    }
                    // 
                    let tooltiptext = !val.devicename || val.devicename.length == 0 ? 'No device name - ' + val.deviceid+" - "+percentage : val.devicename + " - "+ val.deviceid+" - " + percentage;
                    return (
                        <div style={{fontSize:'15px', display: 'contents'}}>
                            <span style={{fontSize:'15px', margin: '13px -5px'}}><Battery70Icon/>{displayName}</span>
                            <Tooltip title={tooltiptext}>
                                
                                    {/* <span style={{marginLeft: '-2px'}}>{displayName}</span> */}
                                    <span style={{fontSize:'15px', margin: '6px 0px'}}id={id} >
                                        <BatteryWidget level={level} style={{ width: '23px', height: '45px' }} />
                                    </span>

                                
                            </Tooltip>

                            {/* <UncontrolledTooltip placement="auto" target={id}>
                            {val.devicename}
                        </UncontrolledTooltip> */}
                        </div>
                        
                    )
                }
            })}

        </Row>
    )
}

const AttributeDisplayElement = ({ alarmObj, attr, asset, isSmall }) => {
    const attributeName = attr.attributename;
    const displayName = attr.displayname;
    const mergeArrays = (arr1, arr2) => {
        return arr1.map((item, i) => {
            if(item.deviceid === arr2[i].deviceid) {
                return Object.assign({}, item, arr2[i])
            }
        });
    };
    let valArray = null;
    let newValArray = [];
    let assetDevices = null;
    let status = false;
    let groupData = null;

    if (asset.attributes && Array.isArray(asset.attributes[attributeName]) && asset.attributes[attributeName].length > 0) {
        valArray = asset.attributes[attributeName];
        assetDevices = asset.devices;
        newValArray = mergeArrays(valArray, assetDevices);
        if (attr.group) {
            groupData = []

            attr.group.forEach(item => {
                let valObj = {
                    ...item,
                    displayVal: null,
                };
                if (asset.attributes[item.attributename] && asset.attributes[item.attributename].length > 0) {
                    valObj = {
                        ...item,
                        displayVal: asset.attributes[item.attributename][0],
                    }
                }
                groupData.push(valObj);
            });
        }

    }
    //  
    let displayVal = valArray ? valArray[0] : null;

    // if (displayVal && alarmObj && alarmObj[displayVal.deviceid] && alarmObj[displayVal.deviceid][attributeName] ){
    //     status = alarmObj[displayVal.deviceid][attributeName].status ? true : false;
    // }

    if (attributeName === 'hexAlarm') {
        return (
            <AlarmDisplayElement attr={attr} val={displayVal} isSmall={isSmall} />
        )
    }
    else if (attributeName === 'Battery') {
        return (
            <BatteryDisplayElement alarmObj={alarmObj} attributeName={attributeName} displayName={displayName} valArray={valArray} isSmall={isSmall} newValArray={newValArray} />
        )
    } else {
        if (attributeName != "CO2") {
            status = displayVal ? displayVal.status : false;
            if (displayVal && alarmObj && alarmObj[displayVal.deviceid] && alarmObj[displayVal.deviceid][attributeName]) {
                status = alarmObj[displayVal.deviceid][attributeName].status ? true : false;
            }
            let groupVal = '';
            let temp = '';
            let templow = '';
            let temphigh = '';
            let windunits = '';
            let windvalue = '';
            if (attributeName === 'Temperature' && groupData && groupData.length === 3) {

                groupData.forEach((val, index) => {
                    if (val.displayVal && val.displayVal.value) {
                        groupVal = groupVal + val.displayVal.value + val.units;
                        groupVal = groupVal + (index == 0 ? ' - ' : index == 1 ? ' + ' : ' ');
                    }
                });
                
                if(groupData[1].displayVal != null && groupData[1].displayVal != undefined) {
                    temp = groupData[1].displayVal.value;
                };

                if(groupData[0].displayVal != null && groupData[0].displayVal != undefined){
                    templow = groupData[0].displayVal.value;
                }
                
                if(groupData[2].displayVal != null && groupData[2].displayVal != undefined) {
                    temphigh = groupData[2].displayVal.value;
                }

                if(temp == null){
                    templow = temp;
                    temphigh = temp;
                }
            }
            if (attributeName === 'Wind_max10' || 'Wind_ave10') {
                
                if (displayVal && attr) {
                    // if (attr.units == 'm/s'){
                    //     windvalue = (displayVal.value * 3.6).toFixed(2);
                    //     windunits = 'km/h';
                    // }else  {
                    //     windvalue = displayVal.value;
                    //     windunits = attr.units;
                    // }
                        windunits = attr.units;
                        windvalue = displayVal.value;

                }
            }
            // ------------- style test -----------------------
            let alarmColor = 'red';
            let blink = 
            keyframes`from {background-color: white; color: black; font-weight: bold;}
            to {background-color: ${alarmColor}; color: white; font-weight: bold;}`;

            // animation: css`${blink} 1s infinite`,
            // const animation = props =>
            // css`
            //     ${pulse} ${props.animationLength} infinite alternate;
            // `
            // const StyledRow = styled(Row)`
            // animation: ${blink} 1s infinite;
            // `

            // ------------------------------------------------

            return (

                <Row style={rowClassGnerator(status, null, attributeName, (displayVal ? (displayVal.value ? GREEN_COLOR : GREY_COLOR) : GREY_COLOR), attr.hasrule, isSmall=true)}>
                    {/* {isSmall &&
                        <span style={{ alignSelf: 'flex-start' }}>
                            <AttribureIcon attributeName={attributeName} />
                        </span>
                    } */}
                        
                        {/* <div style={{ alignSelf: 'flex-start' }}> */}
                            <span style={{fontSize:'15px', display:'flex'}}>
                            <AttribureIcon attributeName={attributeName} />
                            {displayName}
                            </span>
                    {attributeName === 'Temperature' && groupData && groupData.length === 3 ?
                        // groupData.map(val => (
                        //     <span style={{fontSize:'x-small'}}>{val.displayVal ? val.displayVal.value : ''}{' '}{val.units}</span>
                        // ))
                        // <span class="subsup" style={smallTextStyle}>
                        // <span class="subsup" style={{fontSize: '1.5vh', lineHeight: '1.5vh', position: 'relative'}}>
                        // <span class="subsup" style={{fontSize: '0.9rem', lineHeight: '0.9rem'}}>
                        <span class="subsup" style={{verticalAlign:'baseline',fontSize: '15px'}}>
                            {temp ? temp : ''}{' '}{attr.units}
                            <sup style={{verticalAlign:'super'}}>{temphigh}{temp ? attr.units : ""}</sup>
                            <sub style={{verticalAlign:'super'}}>{templow}{temp ? attr.units : ""}</sub>
                        </span>
                        :
                        attributeName === 'Wind_max10' || 'Wind_ave10' ?
                        <span style={{fontSize:'15px'}}>{windvalue ? windvalue : ''}{' '}{windunits}</span>
                        :
                        // <span style={normalTextStyle}>{displayVal ? displayVal.value : ''}{' '}{attr.units}</span>
                        <span style={{fontSize: '15px'}}>{displayVal ? displayVal.value : ''}{' '}{attr.units}</span>
                    }
                    {/* {groupVal && groupVal.length > 0 ?
                    <span style={{fontSize:'x-small'}}>{groupVal}</span>
                    :
                    <span>{displayVal ? displayVal.value : ''}{' '}{attr.units}</span>
                } */}
                    {/* <span>{displayVal ? displayVal.value : ''}{' '}{attr.units}</span> */}
                </Row>

            )
        } else {
            return (<span></span>);
        }
    }
}

const assetnameFormat = (cell, toggle) => {
    const handleDeviceOnClick = (e, assetname) => {
        // alert('yes');
        //  
        e.preventDefault();
        toggle(true, cell);
    }
    return (
        <Button variant="primary outline-custom" href={'#'} onClick={(e) => { handleDeviceOnClick(e, cell.assetname); }}><h5>{cell.assetname}</h5></Button>
    )
}

const timestampFormat = (cell) => {
    if (cell) {
        // if(cell.charAt(0)=="+"){
        //     cell=new Date().getFullYear()+cell.substr(6);
        // }
        let displayTime = new Date(cell).toLocaleString('en-US', { timeZone: TIME_ZONE });
        // let displayTime = new Date(cell).toLocaleString('en-US');
        // let displayTime = moment(cell).toLocaleString('en-US');
        return displayTime;
    } else {
        return null;
    }
}

function rowClassGnerator(status, item, attributeName, color = GREEN_COLOR, hasrule = false, isSmall = false) {
    let backgroupdColor = attributeName === 'Battery' ? 'white' : hasrule ? color : GREY_COLOR; 
    let horizontalAlign = attributeName != 'Battery' && isSmall ? 'space-between' : 'space-evenly'; //'center';
    // let horizontalAlign = attributeName != 'Battery' && isSmall ? 'space-evenly' : 'space-between'; //'center';
    let alarmColor = backgroupdColor;

    if (attributeName !== 'hexAlarm') {
        alarmColor = RED_COLOR;
    }

    // var blink = keyframes`
    //     from {background-color: white; color: black; font-weight: bold;}
    //     to {background-color: ${alarmColor}; color: white; font-weight: bold;}
    // `;
    // `
    // 0% { transform: rotate(0deg); }
    // 100% { transform: rotate(360deg); }
    // `
    let reClass = {
        // color: 'black', 
        // fontWeight: 'normal',
        fontSize:'15px',
        margin: '5px 10px',
        // padding: '5px 30px',
        padding: '6px 13px',
        // justifyContent: horizontalAlign, //'center'
        justifyContent: 'space-between', //'center'
        alignContent: 'center',
        // lineHeight: '30px',
        // height: '30px',
        lineHeight: isSmall ? null : '30px',
        height: isSmall ? null : '30px',
        // height: '3vh',
        backgroundColor: backgroupdColor, //hasrule ? GREEN_COLOR : GREY_COLOR,
        // backgroundColor: YELLOW_COLOR, //hasrule ? GREEN_COLOR : GREY_COLOR,
        color: 'black',
        // position: 'relative',
        // position: 'static',
        // position: 'absolute',
        // '&::after':{
        //     content: '',
        //     width: '100%', 
        //     height: '100%',
        //     backgroundColor: backgroupdColor, 
        //     position: 'absolute',
        //     top: '0',
        //     left: '0',
        //     zIndex: '-1',
        // }
    };

    if (status == true) {
        return ({
            ...reClass,
            // animation: `${blink} 1s infinite`,
            backgroundColor: alarmColor,
            animation: 'alertBlink 1s infinite',
        });
    } else {
        return ({
            ...reClass,
            // backgroundColor: backgroupdColor, //hasrule ? GREEN_COLOR : GREY_COLOR,
            // color: 'white',
        })
    }

    // testing 
    // return ({
    //     ...reClass,
    //     // '::after':{
    //     //     content: '',
    //     //     width: '100%', 
    //     //     height: '100%',
    //     //     backgroundColor: backgroupdColor, 
    //     //     position: 'absolute',
    //     //     top: '0',
    //     //     left: '0',
    //     //     zIndex: '-1',
    //     //     animation: 'alertBlink 1s infinite',
    //     // }
    //     animation: 'alertBlink 1s infinite',
    //  });
}

// function rowClassGnerator(alarmSet, item, attributeName,  hasrule = false, isSmall = false) {
//     let backgroupdColor = attributeName === 'Battery' ? 'white': hasrule ? GREEN_COLOR : GREY_COLOR;
//     let horizontalAlign = attributeName != 'Battery' && isSmall ? 'space-between': 'space-evenly'; //'center';
//     let reClass = {
//         // color: 'black', 
//         // fontWeight: 'normal',
//         margin: '5px 10px',
//         padding:'5px 30px', 
//         justifyContent: horizontalAlign, //'center'
//         alignContent: 'center',
//         lineHeight: '30px',
//         height: '30px',
//         backgroundColor: backgroupdColor, //hasrule ? GREEN_COLOR : GREY_COLOR,
//         color: 'white'
//     };

//     // if (this.props.alarmObj && this.props.alarmObj.msgList){
//     //     for (let alarm of this.props.alarmObj.msgList) {
//     //         if (item.assetname == alarm.assetname && alarm.attributeList && alarm.attributeList.includes(attributeName) && this.props.alarmObj.status == true) {
//     //             return ({
//     //                 padding:'5px', 
//     //                 justifyContent: 'center',
//     //                 alignContent: 'center',
//     //                 lineHeight: '30px',
//     //                 height: '30px',
//     //                 animation: 'fontBlink 1s infinite',
//     //             });
//     //         }
//     //     }
//     // } 
//      
//     if (alarmSet && alarmSet[item.assetid] && alarmSet[item.assetid][attributeName] && alarmSet[item.assetid][attributeName].status == true){

//         return ({
//             margin: '5px 10px',
//             padding:'5px 30px', 
//             justifyContent: horizontalAlign, //'center',
//             alignContent: 'center',
//             lineHeight: '30px',
//             height: '30px',
//             animation: 'fontBlink 1s infinite',
//         });
//     }
//     return reClass;
// }

function setDonut(alarmObj, attributes) {


    let reValue = { status: 0, color: 'white' };
    if (attributes && attributes['hexAlarm'] && attributes['hexAlarm'].length > 0) {
        const color = lightningColorMaper(attributes['hexAlarm'][0].value);
        /*
        if(attributes['hexAlarm'][0].value !== "1111"){
            for(let order in attributes){
                if (attributes[order][0].value === null){
                    color = lightningColorMaper("1111");
                    break;
                }
            }
        }
        */
        const status = attributes['hexAlarm'][0].status ? 1 : 0;
        reValue = {
            ...reValue,
            status,
            color,
        }
    }
    if (attributes) {
        ATTRIBUTE_ORDER && ATTRIBUTE_ORDER.filter(item => item.display && item.attributename != 'hexAlarm').forEach(attr => {
            let attributename = attr.attributename;
            Array.isArray(attributes[attributename]) && attributes[attributename].forEach(vattr => {
                if (vattr.status) {
                    reValue = {
                        ...reValue,
                        status: 1,
                        color: RED_COLOR,
                    }
                }
            });
        });
    }
    if (alarmObj) {
        for (let key in alarmObj) {
            for (let attr of ATTRIBUTE_ORDER) {
                if (attr.hasrule == true && alarmObj[key][attr.attributename] && alarmObj[key][attr.attributename].status == true) {
                    reValue = {
                        ...reValue,
                        status: 1, //0, 
                        color: RED_COLOR,
                    }
                }
            }
        }
    }

    return reValue
}

export default AttributeListWidget;